export class NoteEditorState {
	constructor(
		public text: string = '',
		public on: boolean = false,
		public dirty: boolean = false,
	) {}
}
